import { useState, useEffect } from 'react';
import DigitalnaKancelarija from './pages/DigitalnaKancelarija';
import EnergyAI from './pages/EnergyAI';
import Gravity4AI from './pages/Gravity4AI';
import EnterpriseArchitecture from './pages/EnterpriseArchitecture';
import PowerPlay from './pages/PowerPlay';
import PrivacyPolicy from './pages/PrivacyPolicy';

import './App.css';
import "./fonts/GTWalsheimProRegular.ttf"
import "./fonts/GTWalsheimProLight.ttf"
import "./fonts/GTWalsheimProUltraLight.ttf"
import Header from './Components/Header'
import AboutUs from './Components/AboutUs'
import WhatWeDo from './Components/WhatWeDo'
import OurProducts from './Components/OurProducts'
import OurPartners from './Components/OurPartners'
import ContactUs from './Components/ContactUs'
import Footer from './Components/Footer'

function App() {
  const [path, setPath] = useState(window.location.pathname);

  useEffect(() => {
    const handlePathChange = () => {
      setPath(window.location.pathname);
    };

    window.addEventListener('popstate', handlePathChange);
    return () => {
      window.removeEventListener('popstate', handlePathChange);
    };
  }, []);

  useEffect(() => {
    const isHome = path === '/' || path === '/index.html';
    if (isHome && window.location.hash) {
      const hash = window.location.hash;
      setTimeout(() => {
        const el = document.querySelector(hash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [path]);

  return (
    <div className="App">
      <Header />
      {path === '/digitalnakancelarija' ? (
        <DigitalnaKancelarija />
      ) : path === '/energyai' ? (
        <EnergyAI />
      ) : path === '/gravity4ai' ? (
        <Gravity4AI />
      ) : path.toLowerCase() === '/enterprisearchitecture' ? (
        <EnterpriseArchitecture />
      ) : path.toLowerCase() === '/powerplay' ? (
        <PowerPlay />
      ) : path.toLowerCase().replace(/\/$/, '') === '/privacypolicy' ? (
        <PrivacyPolicy />
      ) : (
        <>
          <div id="link-1"><AboutUs /></div>
          <div id="link-2"><WhatWeDo /></div>
          <div id="link-3"><OurProducts /></div>
          <div id="link-5"><OurPartners /></div>
          <div id="link-6"><ContactUs /></div>
        </>
      )}
      <Footer />
    </div>
  );
}

export default App;
